export const VARIABLE = 'VARIABLE';
